var React = require('react');

function IcMicrophone (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","fillRule":"evenodd","d":"M14 5c0-1.103-.897-2-2-2s-2 .897-2 2v6c0 1.103.897 2 2 2s2-.897 2-2V5zM8 5a4 4 0 018 0v6a4 4 0 01-8 0V5zm12 6V9h-2v2c0 3.309-2.691 6-6 6s-6-2.691-6-6V9H4v2a8.002 8.002 0 007 7.938V22h2v-3.062A8.002 8.002 0 0020 11z","clipRule":"evenodd"}));
}

IcMicrophone.defaultProps = {"fill":"none","viewBox":"0 0 24 24"};

module.exports = IcMicrophone;

IcMicrophone.default = IcMicrophone;
